import { updateOnboardingContactsApi as generatedUpdateOnboardingContactsApi } from '../generated/onboarding/updateOnboardingContacts';

import { getOnboardProfileDraftApi } from './getOnboardProfileDraft';

const updateOnboardingContactsApi = generatedUpdateOnboardingContactsApi.enhanceEndpoints({
  endpoints: {
    updateOnboardingContacts: {
      invalidatesTags: ['Onboard'],
      onQueryStarted: async ({ body }, { dispatch, queryFulfilled }) => {
        const patchResult = dispatch(
          getOnboardProfileDraftApi.util.updateQueryData('getOnboardProfileDraft', undefined, (draft) => {
            draft.contacts = {
              ...draft.contacts,
              ...body,
            };

            if (draft.progress != null) {
              draft.progress.contacts = true;
            } else {
              draft.progress = { contacts: true };
            }
          }),
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
    },
  },
});

export const { useUpdateOnboardingContactsMutation } = updateOnboardingContactsApi;
